var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Breadcrumb',{staticClass:"hidden md:flex text-primary-700 mb-5 lg:mb-3",attrs:{"items":_vm.items}})}
var staticRenderFns = []

export { render, staticRenderFns }